import React from 'react';
import { IconX } from '@tabler/icons-react';
import { UncontrolledTooltip } from 'reactstrap';
import { NSBadge, NSButton } from 'bricks';
import { IDealFilters, IFilterChip, IDealFilterOptions } from '../types';
import { buildActiveFilterChips, hasActiveFilters, toChipDomId } from '../helpers/dealFilters';
import './FilterChips.scss';

export interface IFilterChipsProps {
    filters: IDealFilters;
    filterOptions?: IDealFilterOptions;
    onChange: (filters: IDealFilters) => void;
    onClearAll: () => void;
}

const FilterChips: React.FC<IFilterChipsProps> = ({
    filters,
    filterOptions,
    onChange,
    onClearAll,
}) => {
    const chips: IFilterChip[] = buildActiveFilterChips(filters, filterOptions);
    const hasFilters = hasActiveFilters(filters);

    if (!hasFilters) {
        return null;
    }

    const handleRemoveChip = (chip: IFilterChip) => {
        onChange(chip.nextFilters);
    };

    return (
        <div className="d-flex align-items-center justify-content-end ml-auto overflow-hidden flex-shrink-1" >
            <div className="FilterChips__carousel d-flex overflow-auto">
                {chips.map((chip, index) => {
                    const chipId = toChipDomId(chip.id, index);
                    return (
                        <NSBadge
                            key={chip.id}
                            id={chipId}
                            color="secondary"
                            className="FilterChips__chip d-inline-flex align-items-center mr-1"
                        >
                            <span className="text-truncate">{chip.label}</span>
                            <NSButton
                                icon={IconX}
                                className="ml-1 p-0"
                                callback={() => handleRemoveChip(chip)}
                            />
                            <UncontrolledTooltip
                                target={chipId}
                                placement="bottom"
                                modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
                            >
                                {chip.label}
                            </UncontrolledTooltip>
                        </NSBadge>
                    );
                })}
            </div>
            <NSButton
                color="link"
                className="text-nowrap"
                callback={onClearAll}
            >
                Clear all
            </NSButton>
        </div>
    );
};

export default FilterChips;
